import { updateCategory } from "./knowledgeCenterPage";

updateCategory("faq__tabWapper");